import { getCookie, setCookie } from "../utils/cookie";
import dayjs from "dayjs";
import { getUnitModeFromString, type UnitMode } from "./redux/UnitMode";

const UNIT_MODE_COOKIE = "UNIT_MODE";

export function getUnitCookie(): UnitMode | undefined {
  return getUnitModeFromString(getCookie(UNIT_MODE_COOKIE)?.value);
}

export function setUnitCookie(unitMode: UnitMode) {
  setCookie({ name: UNIT_MODE_COOKIE, value: unitMode, expireDate: dayjs().add(1, "w").toDate() }); // expires in 1 week from NOW
}
